import React from 'react';
import styled from '@emotion/styled';
import CriticalError from './CriticalError';
import CriticalErrorForUser from './CriticalErrorForUser';
import * as Sentry from '@sentry/browser';
import { createCustomLogger } from '~Hooks';

export default class ErrorBoundary extends React.Component<
  {},
  {
    hasError: Error | false;
  }
> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: error };
  }

  componentDidCatch(error: Error) {
    Sentry.captureException(error);
  }

  componentDidMount(): void {
    const mountLogger = createCustomLogger('mount');
    mountLogger.info('ErrorBoundary mounted');
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      const reloadLogger = createCustomLogger('mount');

      return (
        <CriticalError
          stack={this.state.hasError.stack!}
          onClick={() => {
            reloadLogger.info('Location reload: ErrorBoundary');

            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }}
        />
      );
    }

    return this.props.children;
  }
}
